var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUndoTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_948_7750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.6667L6.66667 13.3333L12 8",
    stroke: "#00A7A4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 13.3333H21.3333C22.7478 13.3333 24.1044 13.8952 25.1046 14.8954C26.1048 15.8956 26.6667 17.2522 26.6667 18.6667C26.6667 20.0812 26.1048 21.4377 25.1046 22.4379C24.1044 23.4381 22.7478 24 21.3333 24H20",
    stroke: "#00A7A4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_948_7750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUndoTeal);
export default __webpack_public_path__ + "static/media/Icon_Undo_Teal.ace5469e646565bf6c9640c749b5e877.svg";
export { ForwardRef as ReactComponent };